// import { useState, useEffect, useCallback, useRef } from "react";
// import debounce from "lodash.debounce";
// import { orderSearch } from "../../../../DriftRoutes/contextsApi";
// import { toast } from "react-toastify";

// export const useOrderFilters = ({ orders, allProducts, fetchOrders }) => {
//   const [searchField, setSearchField] = useState("Status");
//   const [searchValue, setSearchValue] = useState("");
//   const [statusFilter, setStatusFilter] = useState("processing");
//   const [quantityView, setQuantityView] = useState("pcs");
//   const [expandQuantityView, setExpandQuantityView] = useState("pcs");
//   const [showCurrentDateDiff, setShowCurrentDateDiff] = useState(true);
//   const [dispatchDatesMap, setDispatchDatesMap] = useState({});
//   const [sortField, setSortField] = useState("Order_ID");
//   const [sortDirection, setSortDirection] = useState("asc");

//   const debouncedSearch = useRef(
//     debounce(async (field, value) => {
//       if (!value) {
//         fetchOrders();
//         return;
//       }

//       if (!field) {
//         toast.error("Please select the search by field");
//         return;
//       }

//       try {
//         const res = await orderSearch({
//           search_field: field,
//           search_value: value,
//         });

//         // Handle search results (implementation depends on API response)
//         console.log("Search results:", res);
//       } catch (error) {
//         console.error("Search failed:", error);
//         toast.error("Search failed. Please try again.");
//       }
//     }, 500)
//   ).current;

//   useEffect(() => {
//     if (!searchValue) {
//       fetchOrders();
//     } else {
//       debouncedSearch(searchField, searchValue);
//     }
//   }, [searchValue, searchField, fetchOrders, debouncedSearch]);

//   const handleSort = (field) => {
//     setSortField(field);
//     setSortDirection(current => current === "asc" ? "desc" : "asc");
//   };

//   const handleSearch = (e) => {
//     setSearchValue(e.target.value);
//   };

//   const clearSearch = () => {
//     setSearchValue("");
//     fetchOrders();
//   };

//   // Filter orders based on status
//   const statusFilteredOrders = orders.filter(order => {
//     if (statusFilter === "all") return true;
//     return order.status?.toLowerCase() === statusFilter.toLowerCase();
//   });

//   // Filter products based on status
//   const statusFilteredProducts = allProducts.filter(product => {
//     if (statusFilter === "all") return true;
//     return product.orderStatus?.toLowerCase() === statusFilter.toLowerCase();
//   });

//   return {
//     searchField,
//     setSearchField,
//     searchValue,
//     setSearchValue,
//     statusFilter,
//     setStatusFilter,
//     quantityView,
//     setQuantityView,
//     expandQuantityView,
//     setExpandQuantityView,
//     showCurrentDateDiff,
//     setShowCurrentDateDiff,
//     dispatchDatesMap,
//     setDispatchDatesMap,
//     sortField,
//     sortDirection,
//     statusFilteredOrders,
//     statusFilteredProducts,
//     handleSort,
//     handleSearch,
//     clearSearch,
//     debouncedSearch,
//   };
// };

import { useState, useEffect, useCallback, useRef } from "react";
import debounce from "lodash.debounce";
import { toast } from "react-toastify";

export const useOrderFilters = ({
  orders,
  allProducts,
  fetchOrders,
  searchOrders,
}) => {
  const [searchField, setSearchField] = useState("Order_ID");
  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("processing");
  const [quantityView, setQuantityView] = useState("pcs");
  const [expandQuantityView, setExpandQuantityView] = useState("pcs");
  const [showCurrentDateDiff, setShowCurrentDateDiff] = useState(true);
  const [dispatchDatesMap, setDispatchDatesMap] = useState({});
  const [sortField, setSortField] = useState("Order_ID");
  const [sortDirection, setSortDirection] = useState("asc");

  const debouncedSearch = useRef(
    debounce(async (field, value) => {
      if (!value) {
        await fetchOrders();
        return;
      }

      if (!field) {
        toast.error("Please select the search by field");
        return;
      }

      await searchOrders(field, value);
    }, 500),
  ).current;

  useEffect(() => {
    if (searchValue) {
      debouncedSearch(searchField, searchValue);
    } else {
      fetchOrders();
    }

    return () => {
      debouncedSearch.cancel();
    };
  }, [searchValue, fetchOrders, searchOrders, debouncedSearch]);

  const handleSort = (field) => {
    setSortField(field);
    setSortDirection((current) => (current === "asc" ? "desc" : "asc"));
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const clearSearch = () => {
    setSearchValue("");
    fetchOrders();
  };

  // Filter orders based on status
  const statusFilteredOrders = orders.filter((order) => {
    if (statusFilter === "all") return true;
    return order.status?.toLowerCase() === statusFilter.toLowerCase();
  });

  // Filter products based on status
  const statusFilteredProducts = allProducts.filter((product) => {
    if (statusFilter === "all") return true;
    return product.orderStatus?.toLowerCase() === statusFilter.toLowerCase();
  });

  return {
    searchField,
    setSearchField,
    searchValue,
    setSearchValue,
    statusFilter,
    setStatusFilter,
    quantityView,
    setQuantityView,
    expandQuantityView,
    setExpandQuantityView,
    showCurrentDateDiff,
    setShowCurrentDateDiff,
    dispatchDatesMap,
    setDispatchDatesMap,
    sortField,
    sortDirection,
    statusFilteredOrders,
    statusFilteredProducts,
    handleSort,
    handleSearch,
    clearSearch,
    debouncedSearch,
  };
};
